import type { RootState } from '@portal-types/store';

import { FeatureFlags } from 'models/featureToggle';

export const getFeatureFlags = (state: RootState) => state.featureFlags.data as FeatureFlags;
export const isFeatureFlagsLoading = (state: RootState) => state.featureFlags.loading;
